module.exports = __webpack_public_path__ + "static/media/POLYGON.ccba55b3.png";